module.exports = __webpack_public_path__ + "img/w18.5d41ab2c.svg";